<div id="container-iclass">
    <div class="center-div">
        <p-card header="Fazer Login"  [style]="{width: '360px'}">
            <div class="ui-g ui-fluid">
            <input type="hidden" id="idEmpresa" name="idEmpresa" pInputText [(ngModel)]="loginParam.idEmpresa">
            <adv-growl></adv-growl>
            <div class="ui-g-12 ui-md-12">
                <div class="ui-inputgroup">
                    <span class="ui-inputgroup-addon"><i class="fas fa-user"></i></span>
                    <input type="text" 
                           name="login" 
                           pInputText 
                           i18n-placeholder 
                           placeholder="CPF/CNPJ"
                           [(ngModel)]="login">
                </div>
            </div>

            <div class="ui-g-12 ui-md-12">
                <div class="ui-inputgroup">
                    <span class="ui-inputgroup-addon"><i class="fas fa-key"></i></span>
                    <input type="password" name="senha" 
                           pInputText
                           i18n-placeholder 
                           placeholder="senha" 
                           [(ngModel)]="loginParam.senha">
                </div>
            </div>
            </div>

        <p-footer>
            <div style="text-align: right">
                <button pButton type="button"
                        i18n-label 
                        label="Entrar" 
                        icon="pi pi-check" (click)="doLogin()">
                </button>
            </div>
        </p-footer>
        </p-card>

        <br />
        <p-card header="Criar uma Conta"  [style]="{width: '360px'}">
            <p-footer>
                <p>
                    <a [routerLink]="['/primeiroAcesso']">
                        <span class="topbar-submenu-icon fas fa-plus-circle"></span>
                        <label i18n="@@labelText35">Criar uma conta</label>
                    </a>
                </p>
            </p-footer>
        </p-card>    
        <br />
    </div>
</div>
